// extracted by mini-css-extract-plugin
module.exports = {"content":"Hero_content__217RT","inner":"Hero_inner__3S-XV","logo":"Hero_logo__1WYL6","cta":"Hero_cta__2x5nv"};